/**
 * LoadingSpinner - Loading indicator component.
 * Phase 19: Enhanced Frontend UI.
 */

import { useLocale } from '../contexts/LocaleContext'

interface LoadingSpinnerProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
}

export function LoadingSpinner({ message, size = 'medium' }: LoadingSpinnerProps) {
  const { t } = useLocale()
  const label = message ?? t('common.loadingDots')
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
  }
  
  return (
    <div className="flex flex-col items-center justify-center p-8" data-testid="loading-spinner">
      <div className={`${sizeClasses[size]} border-4 border-t-[var(--accent-gold)] border-[var(--border)] rounded-full animate-spin`}></div>
      {label && (
        <p className="mt-4 text-sm text-[var(--text-secondary)]">{label}</p>
      )}
    </div>
  )
}
